import { Component } from "react";
import AddPurchaseOrder from "../../../../../../common/custom-form/add-purchase-order.component";

class BillingAddPurchaseOrder extends Component {
    render(){    
        const {data, fieldType, handleFetchPurchaseOrder, financeId} = this.props;
        return(  
                <AddPurchaseOrder 
                    data={data}
                    fieldType={fieldType}
                    handleFetchPurchaseOrder={handleFetchPurchaseOrder}
                    financeId = {financeId}
                    isReadOnly={this.props.isReadOnly}
                    isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                    isReadAndWrite={this.props.isReadAndWrite}
                />
        )
    }
}

export default BillingAddPurchaseOrder;